import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import WXPayService from '../../../services/wxPay.service';
import { currencyFormatter, getDateAsMonthYear, dateWithMonthsDelay as dateWithMonthsOffset, getMonthStartDate } from '../../../utils/methods';

const WXPayWidget = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [currentBillingEstimation, setCurrentBillingEstimation] = useState(0);
  const [avgMrc, setAvgMrc] = useState(0);
  
  useEffect(() => {
    const fetchWXPayData = async () => {
      setLoading(true);
      try {
        const startDate = Date.parse(new Date(getMonthStartDate()).toUTCString());
        const payload = {
          startDate,
          nowTime: Date.parse(new Date().toUTCString())
        };
        
        const response = await WXPayService.getWXPaySummary(payload);
        setCurrentBillingEstimation(response?.data?.currentBillingEstimation || 0);
        setAvgMrc(response?.data?.avgMrc || 0);
      } catch (error) {
        console.error('Error fetching WXPay data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchWXPayData();
  }, []);

  const handleViewDetails = () => {
    navigate('/pay'); // Adjust this path according to your routing setup
  };

  if (loading) {
    return (
      <div className="widget-content">
        <div className="info-row">
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="widget-content">
      <div className="info-row">
        <span>Billing Period Estimate</span>
        <span>
          {currentBillingEstimation < 0 
            ? `($${currencyFormatter(Math.abs(currentBillingEstimation))})`
            : `$${currencyFormatter(currentBillingEstimation)}`}
        </span>
      </div>
      
      <div className="info-row">
        <span>Monthly Recurring Estimate</span>
        <span>
          {avgMrc < 0 
            ? `($${currencyFormatter(Math.abs(avgMrc))})`
            : `$${currencyFormatter(avgMrc)}`}
        </span>
      </div>

      <button 
        onClick={handleViewDetails}
        className="widget-button"
      >
        View Details
      </button>
    </div>
  );
};

export default WXPayWidget;